<form [formGroup]="form">
  <div class="grid gap-x-4 xl:grid-cols-2">
    <app-form-control label="Imię">
      <input
        [formControl]="form.controls.firstName"
        appPrimengInputText
        pInputText />
    </app-form-control>

    <app-form-control label="Nazwisko">
      <input
        [formControl]="form.controls.lastName"
        appPrimengInputText
        pInputText />
    </app-form-control>

    <app-form-control label="Numer telefonu">
      <app-phone-number-with-prefix [formControl]="form.controls.phone" />
    </app-form-control>

    <app-form-control label="E-mail">
      <input
        [formControl]="form.controls.email"
        appPrimengInputText
        pInputText
        type="email" />
    </app-form-control>

    <app-form-control label="Kraj">
      <p-select
        [formControl]="form.controls.countryId"
        [options]="valueOrDefault(countrySelectItems$ | async, [])"
        appPrimengSelect
        [fluid]="true" />
    </app-form-control>

    @if (stateFormControlAvailability$ | async) {
      <app-form-control label="Region">
        <input
          [formControl]="form.controls.state"
          appPrimengInputText
          pInputText />
      </app-form-control>
    }

    <app-form-control label="Adres">
      <input
        [formControl]="form.controls.streetLine1"
        appPrimengInputText
        pInputText />
    </app-form-control>

    <app-form-control label="Adres cd.">
      <input
        [formControl]="form.controls.streetLine2"
        appPrimengInputText
        pInputText />
    </app-form-control>

    <app-form-control label="Kod pocztowy">
      <input
        [formControl]="form.controls.postCode"
        appPrimengInputText
        pInputText />
    </app-form-control>

    <app-form-control label="Miasto">
      <input
        [formControl]="form.controls.city"
        appPrimengInputText
        pInputText />
    </app-form-control>

    <app-form-control label="Nazwa firmy">
      <input
        [formControl]="form.controls.companyName"
        appPrimengInputText
        pInputText />
    </app-form-control>

    <app-form-control
      [hint]="shippingMethodHint$ | async"
      inputId="97f76260-6db7-4e79-bdff-f39b3165a4a1"
      label="Rodzaj wysyłki">
      <p-select
        [formControl]="form.controls.shippingMethodId"
        [options]="valueOrDefault(shippingMethodSelectItems$ | async, [])"
        appPrimengSelect
        [fluid]="true"
        inputId="97f76260-6db7-4e79-bdff-f39b3165a4a1">
      </p-select>
    </app-form-control>

    @if (currentCountryCode$ | async; as country) {
      @if (currentShippingMethod$ | async; as method) {
        @if (method.isInternationalInPostGeowidget) {
          <app-form-control>
            <app-in-post-point-select
              [international]="true"
              [country]="country"
              [formControl]="form.controls.shippingPoint" />
          </app-form-control>
        }

        @if (method.isDomesticInPostGeowidget) {
          <div class="col-span-2">
            <app-form-control>
              <app-in-post-point-select
                [international]="false"
                [country]="country"
                [formControl]="form.controls.shippingPoint" />
            </app-form-control>
          </div>
        }
      }
    }
  </div>

  @let formData = data();

  <div class="flex flex-col gap-4">
    <div class="grid gap-4 rounded-sm bg-gray-50 p-6 xl:grid-cols-2">
      <app-details-view label="Bieżąca kwota dostawy">
        <app-currency
          [amount]="valueOrDefault(formData?.properties?.shippingPrice, 0)" />
      </app-details-view>

      <app-details-view label="Bieżąca kwota subskrypcji">
        @if (formData?.properties?.totalPrice; as totalPrice) {
          <div class="flex gap-1">
            <app-currency [amount]="totalPrice" />
            <div>/</div>
            <div>miesiąc</div>
          </div>
        } @else {
          <app-no-data />
        }
      </app-details-view>
    </div>

    @if (currentShippingMethod$ | async; as method) {
      <div class="grid gap-4 rounded-sm bg-gray-50 p-6 xl:grid-cols-2">
        <app-details-view label="Nowa kwota dostawy">
          <app-currency [amount]="valueOrDefault(method?.shippingPrice, 0)" />
        </app-details-view>

        <app-details-view label="Nowa kwota subskrypcji">
          <div class="flex gap-1">
            <app-currency [amount]="valueOrDefault(method?.totalPrice, 0)" />
            <div>/</div>
            <div>miesiąc</div>
          </div>
        </app-details-view>
      </div>
    }
  </div>

  <div class="mt-4 flex justify-end gap-4">
    @if (pending()) {
      <app-spinner-filled />
    } @else {
      <p-button
        (onClick)="handleSubmitButtonClick()"
        [disabled]="form.invalid"
        appPrimengButton
        label="Zapisz"
        type="submit" />
    }
  </div>
</form>
